import { ITeam } from "../interfaces/team.interface";

export class Team implements ITeam {
    teampk: number;
    teamMemberId: string;
    teamMemberFirstName: string;
    teamMemberName: string;
    teamMemberLanguage: string;
    teamMemberCellularPhone: string;
    teamMemberEmail: string;
    peoplelocationcode: string;
    peoplelocationname: string;
    mobileDevicepk: number;
    mobileDeviceLTEProvider: string;
    mobileDeviceSimNumber: string;
    deletionFlag?: boolean | null;
    roles: string[];

    constructor(team: ITeam) {
        Object.keys(team).map(key => this[key] = team[key]);
    }

    get isActivated(): boolean {
        return this.deletionFlag !== true
    }

    toggleActivation(): void {
        this.deletionFlag = !this.deletionFlag;
    }

    hasRole(rolename: string): boolean {
        return this.roles.find(role => role === rolename) != null;
    }
}